import { useLoyaltyOffersUiEnableGreyedOutOffersQuery } from 'generated/sanity-graphql';

interface IUseEnableGreyedOutOffers {
  enableGreyedOutOffers: boolean;
}

export const useEnableGreyedOutOffers = (skip: boolean): IUseEnableGreyedOutOffers => {
  const { data } = useLoyaltyOffersUiEnableGreyedOutOffersQuery({
    variables: {
      id: 'feature-loyalty-offers-ui-singleton',
    },
    skip,
  });

  return {
    enableGreyedOutOffers: Boolean(data?.LoyaltyOffersUI?.enableGreyedOutOffers),
  };
};
